<template>
<v-progress-linear
  v-show='loading'
    :indeterminate='true'
    :height='3'
    class='ma-0 pa-0'
    color='primary' >
</v-progress-linear>
</template>
<script type="text/javascript">
export default {
  name: 'VuexLoader',
  props: {
    requestId: { type: String, required: true }
  },
  computed: {
    loading () {
      if (this.requestId) {
        let req = this.$store.getters.getRequestById(this.requestId, true)
        return req.loading
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// VuexLoader.vue?7f826e83